"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTailorSsaiManager = void 0;
var player_base_1 = require("@24i/player-base");
var player_utils_1 = require("@24i/player-utils");
var BaseSsaiManager_1 = require("../BaseSsaiManager");
var platformConsts_1 = require("./platformConsts");
var xmlTimeToMilliseconds = function (xmlTime) {
    if (!xmlTime || !xmlTime.startsWith('PT'))
        return undefined;
    var regex = /^PT(([0-9]+)H)?(([0-9]+)M)?(([0-9.]+)S)?$/;
    var matches = xmlTime.match(regex);
    if (!matches)
        return undefined;
    var result = 0;
    var hours = matches[2];
    var minutes = matches[4];
    var seconds = matches[6];
    if (hours)
        result += Number(hours) * 3600000;
    if (minutes)
        result += Number(minutes) * 60000;
    if (seconds)
        result += Number(seconds) * 1000;
    return result;
};
var MINIMUM_UPDATE_INTERVAL = 5000;
var MediaTailorSsaiManager = (function (_super) {
    __extends(MediaTailorSsaiManager, _super);
    function MediaTailorSsaiManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trackingUrl = null;
        _this.trackingAds = [];
        _this.playedAdIds = {};
        _this.verifiedAdIds = new Set();
        _this.trackingIncompleteFirstLoad = false;
        _this.trackingLoadInProgress = false;
        _this.trackingLastRefresh = NaN;
        _this.trackingLastSeekableRangeEnd = NaN;
        _this.trackingLiveOffset = NaN;
        return _this;
    }
    MediaTailorSsaiManager.prototype.getAdvertisements = function () {
        var _this = this;
        var allowedRange = this.getAllowedRange();
        return this.trackingAds
            .flatMap(this.extractAdvertisement, this)
            .filter(function (advertisement) {
            return _this.filterByRange(advertisement, allowedRange);
        });
    };
    MediaTailorSsaiManager.prototype.canLoad = function (source) {
        return Boolean(this.extractSessionUrl(source));
    };
    MediaTailorSsaiManager.prototype.load = function (source) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionUrl, sessionBody, sessionRequest, session, sessionResponse, manifestUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionUrl = this.extractSessionUrl(source);
                        if (!sessionUrl)
                            return [2, source];
                        sessionBody = this.extractSessionBody(source);
                        sessionRequest = {
                            method: 'POST',
                        };
                        if (sessionBody) {
                            sessionRequest.body = JSON.stringify(sessionBody);
                            sessionRequest.headers = {
                                'Content-Type': 'application/json',
                            };
                        }
                        return [4, fetch(sessionUrl, sessionRequest)];
                    case 1:
                        session = _a.sent();
                        return [4, session.json()];
                    case 2:
                        sessionResponse = (_a.sent());
                        manifestUrl = this.combineUrl(sessionUrl, sessionResponse.manifestUrl);
                        this.trackingUrl = this.combineUrl(sessionUrl, sessionResponse.trackingUrl);
                        this.playedAdIds = {};
                        this.verifiedAdIds.clear();
                        this.trackingIncompleteFirstLoad = true;
                        return [4, this.loadTracking()];
                    case 3:
                        _a.sent();
                        return [2, _super.prototype.load.call(this, __assign(__assign({}, source), { url: manifestUrl }))];
                }
            });
        });
    };
    MediaTailorSsaiManager.prototype.extractSessionUrl = function (source) {
        var url = source.url, ssai = source.ssai;
        if (!ssai || ssai.type !== 'awsmediatailor')
            return null;
        var mediatailor = ssai;
        if (mediatailor.sessionUrl) {
            return mediatailor.sessionUrl;
        }
        if (!url || !url.includes('mediatailor')) {
            return null;
        }
        if (url.includes('.amazonaws.com/v1/master/')) {
            return url.replace('.amazonaws.com/v1/master/', '.amazonaws.com/v1/session/');
        }
        if (url.includes('.amazonaws.com/v1/dash/')) {
            return url.replace('.amazonaws.com/v1/dash/', '.amazonaws.com/v1/session/');
        }
        return null;
    };
    MediaTailorSsaiManager.prototype.extractSessionBody = function (source) {
        var _a;
        var ssai = source.ssai;
        if (ssai.type !== 'awsmediatailor')
            return undefined;
        var mediatailor = ssai;
        return {
            adsParams: (_a = mediatailor.adsParams) !== null && _a !== void 0 ? _a : {},
        };
    };
    MediaTailorSsaiManager.prototype.combineUrl = function (base, relative) {
        if (relative.startsWith('https://'))
            return relative;
        var baseParsed = base.match(/^(https:\/\/[^\/]+)(|([^#?]*)\/([^#\/?]*))($|[#?].*$)/);
        var beforePath = baseParsed[1];
        var forRelativePath = baseParsed[3];
        if (relative.startsWith('/'))
            return "" + beforePath + relative;
        if (forRelativePath)
            return "" + beforePath + forRelativePath + "/" + relative;
        return beforePath + "/" + relative;
    };
    MediaTailorSsaiManager.prototype.loadTracking = function () {
        return __awaiter(this, void 0, void 0, function () {
            var trackingResponse, trackingJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(this.trackingUrl, {
                            cache: 'no-store',
                        })];
                    case 1:
                        trackingResponse = _a.sent();
                        return [4, trackingResponse.json()];
                    case 2:
                        trackingJson = (_a.sent());
                        this.trackingAds = trackingJson.avails.flatMap(function (avail) { return avail.ads; });
                        return [2];
                }
            });
        });
    };
    MediaTailorSsaiManager.prototype.getAllowedRange = function () {
        var _a = this.player, live = _a.live, duration = _a.duration, timeshiftRange = _a.timeshiftRange;
        if (live)
            return timeshiftRange;
        return { start: 0, end: duration };
    };
    MediaTailorSsaiManager.prototype.extractAdvertisement = function (trackingAd, adBreakIndex) {
        var _a, _b;
        var title = (_a = trackingAd.adTitle) !== null && _a !== void 0 ? _a : '';
        var start = player_utils_1.secondsToMilliseconds(trackingAd.startTimeInSeconds);
        var duration = player_utils_1.secondsToMilliseconds(trackingAd.durationInSeconds);
        var played = (_b = this.playedAdIds[trackingAd.adId]) !== null && _b !== void 0 ? _b : player_base_1.ITimelineEventPlayed.UNPLAYED;
        var skipOffset = xmlTimeToMilliseconds(trackingAd.skipOffset);
        var lifeOffset = Number.isFinite(this.trackingLiveOffset)
            ? this.trackingLiveOffset
            : 0;
        return {
            type: player_base_1.ISourceTimelineEventType.ADVERTISEMENT,
            start: start + lifeOffset,
            end: start + duration + lifeOffset,
            played: played,
            canSkip: false,
            skipOffset: skipOffset,
            trackingAd: trackingAd,
            adBreak: {
                adBreakIndex: adBreakIndex,
                adBreakOffset: start + lifeOffset,
                totalAds: 1,
            },
            ad: {
                adBreakIndex: adBreakIndex,
                adPosition: 0,
                title: title,
                description: '',
                duration: duration,
                skipOffset: skipOffset,
                inStreamAdvertisement: true,
            },
        };
    };
    MediaTailorSsaiManager.prototype.filterByRange = function (advertisement, range) {
        if (advertisement.end < range.start)
            return false;
        if (advertisement.start > range.end)
            return false;
        return true;
    };
    MediaTailorSsaiManager.prototype.onAdTracking = function (advertisement, vastTrackingEvent) {
        var _this = this;
        _super.prototype.onAdTracking.call(this, advertisement, vastTrackingEvent);
        var tailorAdvertisement = advertisement;
        var _a = tailorAdvertisement.trackingAd, adId = _a.adId, trackingEvents = _a.trackingEvents, adVerifications = _a.adVerifications;
        var events = trackingEvents.filter(function (event) { return event.eventType === vastTrackingEvent; });
        if (!this.verifiedAdIds.has(adId)) {
            this.verifiedAdIds.add(adId);
            adVerifications
                .flatMap(function (verification) { return verification.trackingEvents; })
                .filter(function (event) { return event.event === 'verificationNotExecuted'; })
                .map(function (event) { return event.uri.replace('[REASON]', '2'); })
                .forEach(function (beaconUrl) { return _this.sendBeacon(beaconUrl); });
        }
        if (vastTrackingEvent === 'complete') {
            this.playedAdIds[adId] = player_base_1.ITimelineEventPlayed.PLAYED;
        }
        if (vastTrackingEvent === 'skip') {
            this.playedAdIds[adId] = player_base_1.ITimelineEventPlayed.SKIPPED;
        }
        if (!this.playedAdIds[adId] ||
            this.playedAdIds[adId] === player_base_1.ITimelineEventPlayed.UNPLAYED) {
            this.playedAdIds[adId] = advertisement.canSkip
                ? player_base_1.ITimelineEventPlayed.PLAYING_SKIPPABLE
                : player_base_1.ITimelineEventPlayed.PLAYING_UNSKIPPABLE;
        }
        if (vastTrackingEvent !== 'progress') {
            events
                .flatMap(function (event) { return event.beaconUrls; })
                .forEach(function (url) { return _this.sendBeacon(url); });
        }
    };
    MediaTailorSsaiManager.prototype.sendBeacon = function (beaconUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, fetch(beaconUrl)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    MediaTailorSsaiManager.prototype.onLoadedMetadata = function () {
        this.initializeLiveOffset();
        _super.prototype.onLoadedMetadata.call(this);
        this.triggerTrackingLoad(true);
    };
    MediaTailorSsaiManager.prototype.onTimeUpdate = function () {
        this.initializeLiveOffset();
        _super.prototype.onTimeUpdate.call(this);
        this.maybeTriggerTrackingUpdate();
    };
    MediaTailorSsaiManager.prototype.initializeLiveOffset = function () {
        var _a = this.player, live = _a.live, currentTime = _a.currentTime, duration = _a.duration, timeshiftRange = _a.timeshiftRange, bufferedRanges = _a.bufferedRanges, hasLoadedMetadata = _a.hasLoadedMetadata;
        if (!hasLoadedMetadata)
            return;
        if (!live && duration > 0) {
            this.trackingLiveOffset = 0;
        }
        else if (live && !Number.isFinite(this.trackingLiveOffset)) {
            var offsetOptions = [];
            if (platformConsts_1.isPlatformIos) {
                offsetOptions.push(currentTime);
            }
            if (timeshiftRange.end) {
                offsetOptions.push(timeshiftRange.start);
            }
            if (bufferedRanges.length > 0 &&
                bufferedRanges[bufferedRanges.length - 1].end) {
                offsetOptions.push(bufferedRanges[0].start);
            }
            if (offsetOptions.length > 0) {
                this.trackingLiveOffset = Math.min.apply(Math, offsetOptions);
            }
        }
    };
    MediaTailorSsaiManager.prototype.maybeTriggerTrackingUpdate = function () {
        var _a = this.player, live = _a.live, hasLoadedMetadata = _a.hasLoadedMetadata;
        if (!hasLoadedMetadata || !live)
            return;
        if (!Number.isFinite(this.trackingLastRefresh))
            return;
        var now = Date.now();
        if (this.trackingLastRefresh + MINIMUM_UPDATE_INTERVAL >= now)
            return;
        this.trackingLastRefresh = now;
        this.triggerTrackingLoad(false);
    };
    MediaTailorSsaiManager.prototype.triggerTrackingLoad = function (firstLoad) {
        var _this = this;
        if (firstLoad === void 0) { firstLoad = false; }
        if (!this.trackingUrl || this.trackingLoadInProgress)
            return;
        this.trackingIncompleteFirstLoad = firstLoad;
        this.trackingLoadInProgress = true;
        this.trackingLastRefresh = Date.now();
        this.loadTracking()
            .then(function () {
            _this.trackingIncompleteFirstLoad = false;
            _this.trackingLoadInProgress = false;
            _this.updateAdvertisements();
        })
            .catch(function (error) {
            _this.trackingIncompleteFirstLoad = false;
            _this.trackingLoadInProgress = false;
            var logger = _this.player.logger;
            var logError = firstLoad ? logger.warn : logger.info;
            logError('Failed to load advertisements', error);
        });
    };
    MediaTailorSsaiManager.prototype.unload = function () {
        _super.prototype.unload.call(this);
        this.trackingAds = [];
        this.trackingUrl = null;
        this.verifiedAdIds.clear();
        this.playedAdIds = {};
        this.trackingIncompleteFirstLoad = false;
        this.trackingLoadInProgress = false;
        this.trackingLiveOffset = NaN;
        this.trackingLastRefresh = NaN;
    };
    MediaTailorSsaiManager.prototype.shouldPostponeInitialSeek = function () {
        if (!this.trackingUrl || this.trackingAds.length > 0)
            return false;
        return this.trackingIncompleteFirstLoad;
    };
    return MediaTailorSsaiManager;
}(BaseSsaiManager_1.BaseSsaiManager));
exports.MediaTailorSsaiManager = MediaTailorSsaiManager;
//# sourceMappingURL=index.js.map